import React, { useEffect, useState } from 'react'
import { Menu } from '@headlessui/react';
import { MentorService } from '../../services/mentor';
import { toast } from 'react-toastify';
import { normalDate } from '../../helpers/date.handler'
import { Link, useHistory } from 'react-router-dom';
import { ReactComponent as Vthreedots } from '../../assets/icons/threedots.svg';

import DeleteMentor from './DeleteMentor';

const Mentors = () => {

    let [mentors, setMentors] = useState([])
    let [isOpen, setIsOpen] = useState(false)
    let [selectedMentor, setSelectedMentor] = useState({})

    function closeModal() {
        setIsOpen(false)
    }

    function openModal() {
        setIsOpen(true)
    }

    const history = useHistory();

    const getMentors = async () => {
        await MentorService.getAllMentors().then(res => {
            if (res.status === 200) {
                setMentors(res.data)
            }
        }).catch(e => {
            console.log(e);
            toast.error(e.response.data)
        });

    }

    // const handleDeleteMentor = async (uuid) => {
    //     await MentorService.deleteMentor(uuid).then(res => {
    //         if (res.status === 200) {
    //             getMentors()
    //         }
    //     }).catch(e => {
    //         console.error(e)
    //     })
    // }

    useEffect(() => {
        getMentors();
    }, [])

    return (
        <div className="users w-100 h-full flex flex-col">
            {isOpen && <DeleteMentor
                getMentors={getMentors}
                uuid={selectedMentor.uuid}
                openModal={openModal}
                closeModal={closeModal}
                isOpen={isOpen}
            />}
            <div className="settings-title">
                <div className="flex w-full basis-full">
                    <div className='w-50 basis-6/12	'>
                        <h1 className='text-2xl text-black font-medium mb-0'>All Mentors ({mentors.length})</h1>
                    </div>
                    <div className='w-50 basis-6/12	 items-end flex justify-end'>
                        {/* <label className="relative flex items-center">

                            <span className="absolute inset-y-0 left-0 flex items-center pl-2">
                                <svg className="h-5 w-5 fill-slate-300" viewBox="4 2 20 20">  <path fillRule="evenodd" clipRule="evenodd" d="M6.10369 6.1455C3.29877 9.00618 3.29877 13.6442 6.10369 16.5049C8.90862 19.3656 13.4563 19.3656 16.2612 16.5049C19.0662 13.6442 19.0662 9.00618 16.2612 6.1455C13.4563 3.28483 8.90862 3.28483 6.10369 6.1455ZM7.2126 7.27645C9.40509 5.04037 12.9598 5.04037 15.1523 7.27645C17.3448 9.51252 17.3448 13.1379 15.1523 15.374C12.9598 17.6101 9.40509 17.6101 7.2126 15.374C5.0201 13.1379 5.0201 9.51252 7.2126 7.27645Z" fill="#696974" />
                                    <path d="M19.7562 18.6204L16.5182 15.3181C15.779 14.5641 14.6701 15.6951 15.4093 16.449L18.6473 19.7514C19.3866 20.5053 20.4955 19.3744 19.7562 18.6204Z" fill="#696974" /></svg>
                            </span>
                            <input className="placeholder:text-slate-400 block bg-white w-full border border-solid border-black400 rounded py-1 pl-8 pr-3 focus:outline-none focus:border-black400 focus:ring-black400 " placeholder="Search" type="text" name="search" />
                            <button className='bg-black200 text-14 font-medium text-black800 px-4 py-1 rounded border border-solid	border-black200 ml-2 hover:bg-primary hover:text-white'>Search</button>
                        </label> */}
                        <div className='ml-6'>
                            <Link to="new-mentor">
                                <button className='flex items-center text-14 font-medium text-white !bg-primary px-2 py-1 rounded hover:opacity-90'><svg className="mr4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><mask id="path-1-inside-1_1117_451" fill="white"><path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z"></path></mask><path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z" fill="white"></path><path d="M12.6665 11.3335H9.66653V14.3335H12.6665V11.3335ZM12.6665 12.6668V9.66678H9.66653V12.6668H12.6665ZM11.3332 12.6668H14.3332V9.66678H11.3332V12.6668ZM11.3332 11.3335V14.3335H14.3332V11.3335H11.3332ZM12.6665 14.3335H17.3331V8.33347H12.6665V14.3335ZM17.3331 14.3335C16.0444 14.3335 14.9998 13.2888 14.9998 12.0001H20.9998C20.9998 9.97509 19.3581 8.33347 17.3331 8.33347V14.3335ZM14.9998 12.0001C14.9998 10.7115 16.0444 9.66678 17.3331 9.66678V15.6668C19.3581 15.6668 20.9998 14.0252 20.9998 12.0001H14.9998ZM17.3331 9.66678H12.6665V15.6668H17.3331V9.66678ZM9.66653 12.6668V17.3333H15.6665V12.6668H9.66653ZM9.66653 17.3333C9.66653 16.0447 10.7112 15 11.9999 15V21C14.0249 21 15.6665 19.3584 15.6665 17.3333H9.66653ZM11.9999 15C13.2885 15 14.3332 16.0447 14.3332 17.3333H8.33322C8.33322 19.3584 9.97484 21 11.9999 21V15ZM14.3332 17.3333V12.6668H8.33322V17.3333H14.3332ZM11.3332 9.66678H6.66665V15.6668H11.3332V9.66678ZM6.66665 9.66678C7.95533 9.66678 9 10.7115 9 12.0001H3C3 14.0252 4.64162 15.6668 6.66665 15.6668V9.66678ZM9 12.0001C9 13.2888 7.95533 14.3335 6.66665 14.3335V8.33347C4.64162 8.33347 3 9.97509 3 12.0001H9ZM6.66665 14.3335H11.3332V8.33347H6.66665V14.3335ZM14.3332 11.3335V6.6669H8.33322V11.3335H14.3332ZM14.3332 6.6669C14.3332 7.95557 13.2885 9.00024 11.9999 9.00024V3.00024C9.97484 3.00024 8.33322 4.64186 8.33322 6.6669H14.3332ZM11.9999 9.00024C10.7112 9.00024 9.66653 7.95557 9.66653 6.6669H15.6665C15.6665 4.64186 14.0249 3.00024 11.9999 3.00024V9.00024ZM9.66653 6.6669V11.3335H15.6665V6.6669H9.66653Z" fill="white" mask="url(#path-1-inside-1_1117_451)"></path></svg>
                                    Create New
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="urer-table ml-24 mt-24">
                <div className="def-table pr-24 !h-full w-full">
                    {mentors.length !== 0 ?
                        <table className="table w-full font-worksans">
                            <thead className='text-left bg-black100 rounded-lg '>
                                <tr className='px-4 py-2'>
                                    <th className='w-10'>S.No</th>
                                    <th className=''>Mentor Name</th>
                                    <th className=''>Designation</th>
                                    <th className=''>Company</th>
                                    <th>Category</th>
                                    <th>Date Added</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {mentors && mentors.map(
                                    (mentor, index) =>
                                        <tr key={mentor._id}>
                                            <td className='pl-6'>{index + 1}</td>
                                            <td className=''><span className='mentor-name' title={(mentor.name)}>{mentor.name}</span></td>
                                            <td className=''><span className='designation' title={(mentor.designation)}>{mentor.designation}</span></td>
                                            <td className=''><span className='compnay-name' title={(mentor.company)}>{mentor.company}</span></td>
                                            <td>{mentor.category}</td>
                                            <td>{normalDate(mentor.created_on)}</td>

                                            <td className='pl-0 pr-5 dropdown view-more show'>
                                                <button className="bg-tr border-0 d-table !ml-4" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <Vthreedots className="h-4" />
                                                </button>

                                                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                                    <a
                                                        onClick={() => {
                                                            history.push(`/settings/mentors/edit-mentor/${mentor.uuid}`)
                                                        }}
                                                        className="dropdown-item" >
                                                        Edit Mentor
                                                    </a>
                                                    <a className="dropdown-item del-menu text-capitalize"
                                                        onClick={() => {
                                                            setSelectedMentor(mentor);
                                                            openModal();
                                                        }}>
                                                        Delete Mentor
                                                    </a>
                                                </div>
                                            </td>
                                        </tr>
                                )
                                }

                            </tbody>
                        </table>
                        :
                        <>"No mentors found !</>
                    }

                </div>
            </div>
        </div>
    )
}

export default Mentors;